<template>
  <div class="card form-card">
    <div class="card-body px-4 py-4 d-flex flex-column">
      <div class="d-flex align-items-center mb-3 form-header">
        <img :src="iconHeltMetricsFilled" alt="Reembolso anuidade" />
        <span class="form-title">Reembolso anuidade</span>
      </div>

      <div class="type-selector" v-if="!sentSuccessfully">
        <label class="type-selector__label">Selecione o tipo:</label>

        <div class="type-selector__grid">
          <div
            v-for="option in requestTypeOptions"
            :key="option.id"
            class="type-selector__option"
          >
            <input
              type="radio"
              :id="option.id"
              name="tipoEntidade"
              :value="option.label"
              v-model="selectedRequestType"
              class="type-selector__input"
            />
            <label class="type-selector__text" :for="option.id">
              <span class="type-selector__name">{{ option.label }}</span>
              <span class="type-selector__value"
                >Valor teto: {{ option.ceiling }}</span
              >
            </label>
          </div>
        </div>
      </div>

      <div class="send-file" v-if="!sentSuccessfully">
        <div v-if="selectedRequestType" class="document-description mb-3">
          <p v-if="selectedRequestType === 'ACM'" class="mb-0">
            Para pagamento da anuidade da ACM, anexar a
            <strong>declaração de associado</strong>.
          </p>
          <p v-if="selectedRequestType === 'CREMESC'" class="mb-0">
            Para pagamento da anuidade do CRM-SC, anexar a
            <strong>Certidão de Regularidade Financeira</strong>.
          </p>
          <p v-if="selectedRequestType === 'SIMESC'" class="mb-0">
            Para pagamento da anuidade do SIMESC, anexar a
            <strong>declaração de filiação</strong>.
          </p>
        </div>

        <div
          class="upload-box"
          @click="$refs.fileInput.click()"
          :class="{ disabled: !selectedRequestType }"
        >
          <img :src="iconUploadSvg" alt="Upload de arquivo" />
          <span class="upload-text">{{ "Anexar Comprovante" }}</span>
        </div>
        <p v-if="!this.errorMessage" class="file-hint mt-1 mb-0">
          O arquivo deve ter até 20MB.
        </p>

        <div class="file-upload" v-if="file">
          <span class="icon-type-file"
            ><img :src="iconPdf" alt="Arquivo PDF"
          /></span>

          <span>{{ file ? file.name : "Nome do arquivo" }}</span>
          <span class="icon-bin"
            ><img :src="iconBin" alt="Excluir" @click="deleteFile"
          /></span>
        </div>
      </div>
      <div v-if="this.numberProtocol">
        <div class="success-file">
          <div>
            <img
              :src="iconChecked"
              class="icon-checked"
              alt="Enviado com sucesso"
            />
          </div>
          <div>
            Comprovante enviado com sucesso em {{ getCurrentDate }}.
            <span class="line-break"
              ><strong>Protocolo {{ this.numberProtocol }}</strong></span
            >
          </div>
        </div>
        <hr class="bar" />
        <div class="reply-now">
          <p class="reply-now_title">Conclua sua solicitação</p>
          <p>
            O próximo passo para liberação do pagamento é o preenchimento da
            <strong>Pesquisa de Satisfação e Saúde Cooperados 2026</strong>.
          </p>
        </div>
      </div>
      <div v-if="this.errorMessage" class="error-message">
        <img :src="iconInfo" class="icon-info" alt="Informação" />
        {{ this.errorMessage }}
      </div>

      <input
        type="file"
        ref="fileInput"
        class="d-none"
        accept="application/pdf"
        @change="handleFileUpload"
      />

      <div
        class="d-flex mt-auto"
        :class="
          sentSuccessfully
            ? 'justify-content-between align-items-center w-100'
            : 'justify-content-end'
        "
      >
        <button
          v-if="sentSuccessfully"
          class="btn btn-request-again"
          @click="resetForm"
        >
          <img :src="iconArrowBack" alt="Voltar" class="icon-arrow-back" />
          Solicitar novamente
        </button>
        <button
          v-if="!sentSuccessfully"
          class="btn btn-submit"
          @click="submit"
          :disabled="!isFile || !selectedRequestType"
        >
          Solicitar reembolso
        </button>
        <button
          v-if="sentSuccessfully"
          class="btn btn-reply-now"
          @click="redirectPage"
        >
          Responder agora
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import iconHeltMetricsFilled from "../../../assets/images/health_metrics_filled.svg";
import iconUploadSvg from "../../../assets/images/upload_barra.svg";
import iconBin from "../../../assets/images/bin.svg";
import iconPdf from "../../../assets/images/pdf.svg";
import iconInfo from "../../../assets/images/MDI-alert-circle-outline.svg";
import iconChecked from "../../../assets/images/panel-economic-update.svg";
import iconArrowBack from "../../../assets/images/arrow_back.svg";
import JMJSolicitation from "../../../static-data/JMJSolicitation";
import { addOtherSolicitation } from "../../../services/other-solicitation/other-solicitation";
import { inject } from "@vue/composition-api";
import {
  APP_SATISFACTION_SURVEY_FORM,
  APP_JMJ_SUBCATEGORY_CREMESC,
  APP_JMJ_SUBCATEGORY_ACM,
  APP_JMJ_SUBCATEGORY_SIMESC,
} from "../../../services/urls/enviroment-variables";

export default {
  name: "AnnuityRefundForm",
  setup() {
    const globalLoading = inject("globalLoading");
    return { globalLoading };
  },
  data() {
    return {
      file: null,
      iconHeltMetricsFilled,
      iconUploadSvg,
      iconBin,
      iconPdf,
      iconInfo,
      iconChecked,
      iconArrowBack,
      errorMessage: "",
      isFile: false,
      sentSuccessfully: false,
      numberProtocol: null,
      selectedRequestType: "",
      requestTypeOptions: [
        {
          id: "acm",
          label: "ACM",
          value: "ANNUITY_ACM",
          ceiling: "R$ 1.100,00",
        },
        {
          id: "cremesc",
          label: "CREMESC",
          value: "ANNUITY_CREMESC",
          ceiling: "R$ 948,00",
        },
        {
          id: "simesc",
          label: "SIMESC",
          value: "ANNUITY_SIMESC",
          ceiling: "R$ 1.500,00",
        },
      ],
    };
  },
  computed: {
    getSolicitations() {
      return JMJSolicitation;
    },
    getCurrentDate() {
      const hoje = new Date();

      const dia = String(hoje.getDate()).padStart(2, "0");
      const mes = String(hoje.getMonth() + 1).padStart(2, "0");
      const ano = hoje.getFullYear();

      return `${dia}/${mes}/${ano}`;
    },
  },
  methods: {
    redirectPage() {
      window.open(APP_SATISFACTION_SURVEY_FORM, "_blank");
    },
    resetForm() {
      this.sentSuccessfully = false;
      this.errorMessage = "";
      this.numberProtocol = null;
      this.selectedRequestType = "";
      this.file = null;
      this.isFile = false;
      if (this.$refs.fileInput) this.$refs.fileInput.value = "";
    },

    handleFileUpload(event) {
      const file = event.target.files[0];
      if (!file) return;
      const extension = file.name.split(".").pop()?.toLowerCase();
      const type = file.type;
      const maximumLimit = 20 * 1024 * 1024;
      if (file.size > maximumLimit) {
        this.errorMessage =
          "O anexo excede 20MB. Tente reduzir a resolução ou comprimir o arquivo.";
        this.file = null;
        this.isFile = false;
        return;
      }
      const isPdf = extension === "pdf" || type === "application/pdf";
      if (!isPdf) {
        this.errorMessage =
          "Arquivo inválido. Favor enviar arquivo com extensão PDF.";
        this.file = null;
        this.isFile = false;
        return;
      }
      this.file = file;
      this.errorMessage = "";
      this.isFile = true;
    },
    deleteFile() {
      this.file = null;
      this.errorMessage = "";
      this.isFile = false;
      if (this.$refs.fileInput) this.$refs.fileInput.value = "";
    },
    async submit() {
      try {
        this.globalLoading = true;

        const configJMJ = this.getConfigJMJ();

        if (!configJMJ) {
          this.sentSuccessfully = false;
          this.errorMessage =
            "Algo deu errado. Não conseguimos processar sua solicitação agora. Por favor, tente novamente em instantes.";

          return;
        }

        this.sentSuccessfully = true;
        const requestPayload = {
          solicitation: configJMJ.solicitation,
          category: configJMJ.category,
          subCategory: configJMJ.subCategory,
          manifestation: configJMJ.manifestation,
          message: configJMJ.message,
        };

        const files = this.file ? [this.file] : [];

        this.numberProtocol = await addOtherSolicitation(requestPayload, files);

        this.sentSuccessfully = this.numberProtocol != null;
      } catch (error) {
        this.sentSuccessfully = false;
        this.errorMessage =
          "Algo deu errado. Não conseguimos processar sua solicitação agora. Por favor, tente novamente em instantes.";
      } finally {
        this.globalLoading = false;
      }
    },
    getConfigJMJ() {
      const configJMJ = JMJSolicitation.find(
        (item) => item.id === "ANNUITY_REFUND",
      );
      if (!configJMJ) return null;

      let subCategory = configJMJ.subCategory;
      if (this.selectedRequestType === "CREMESC")
        subCategory = parseInt(APP_JMJ_SUBCATEGORY_CREMESC);
      else if (this.selectedRequestType === "ACM")
        subCategory = parseInt(APP_JMJ_SUBCATEGORY_ACM);
      else if (this.selectedRequestType === "SIMESC")
        subCategory = parseInt(APP_JMJ_SUBCATEGORY_SIMESC);

      return {
        solicitation: configJMJ.name,
        category: configJMJ.category,
        subCategory: subCategory,
        manifestation: configJMJ.manifestation,
        message: `Solicitação de Reembolso de Anuidade.\nTipo: ${this.selectedRequestType}`,
      };
    },
  },
};
</script>

<style scoped>
/* =========================================================
   Layout principal
   ========================================================= */

/* =========================================================
   Seleção de tipo (radio group)
   ========================================================= */

.type-selector {
  margin-bottom: 16px;
}

.type-selector__label {
  display: block;
  color: var(--dark-2);
  font-size: 16px;
  margin-bottom: 12px;
}

.type-selector__grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px 0;
}

.type-selector__option {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  margin-bottom: 10px;
}

.type-selector__input {
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  margin: 0;
  cursor: pointer;
  accent-color: var(--green-4);
}

.type-selector__text {
  display: flex;
  flex-direction: column;
  cursor: pointer;
  margin: 0;
}

.type-selector__name {
  font-size: 16px;
  color: var(--dark-2);
  line-height: 20px;
}

.type-selector__value {
  font-size: 14px;
  color: var(--green-5);
  line-height: 18px;
}

.form-card {
  border-radius: 12px;
  border: 1px solid var(--background-1);
}

@media (max-width: 767px) {
  .type-selector__grid {
    grid-template-columns: 1fr;
  }
}

/* =========================================================
   Cabeçalho do formulário
   ========================================================= */

.form-header {
  gap: 12px;
}

.form-title {
  color: var(--dark-3);
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
}

/* =========================================================
   Área de upload de arquivo
   ========================================================= */

.document-description {
  color: var(--dark-2);
  font-size: 14px;
  line-height: 20px;
}

.upload-box {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background-color: var(--background-3);
  border-radius: 4px;
  padding: 6px 12px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.upload-box:hover:not(.disabled) {
  background-color: var(--grey-7);
}

.upload-box.disabled {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
}

.upload-text {
  color: var(--green-5);
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
}

.file-hint {
  color: var(--grey-9);
  font-size: 12.8px;
  font-weight: 400;
  line-height: 19.2px;
}

.file-upload {
  margin-top: 10px;
  color: var(--dark-3);
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
}

.icon-type-file {
  margin-right: 8px;
}

.icon-bin {
  margin-left: 10px;
  padding: 3px;
  border-radius: 4px;
  transition: background-color 0.2s ease;
}

.icon-bin:hover {
  cursor: pointer;
  background-color: var(--grey-6);
}

/* =========================================================
   Estado de sucesso
   ========================================================= */

.success-file {
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--green-4);
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
}

.line-break {
  display: block;
}

.bar {
  color: var(--grey-5);
  width: 430px;
  height: 1px;
}

/* =========================================================
   Bloco "Responder agora"
   ========================================================= */

.reply-now p {
  color: var(--dark-2);
  font-size: 14px;
  line-height: 24px;
}

.reply-now p.reply-now_title {
  color: var(--orange-3);
  font-size: 16px;
  font-weight: 700;
  line-height: 19.2px;
}

/* =========================================================
   Mensagem de erro
   ========================================================= */

.error-message {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 10px;
  color: var(--danger-3);
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
}

.icon-checked,
.icon-info {
  width: 16px;
  flex-shrink: 0;
}

/* =========================================================
   Botões de ação
   ========================================================= */

.btn-submit {
  background-color: var(--green-4);
  color: var(--background-1);
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  transition: background-color 0.2s ease;
  padding: 6px 12px;
  margin-top: 10px;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.btn-submit:not(:disabled):hover {
  background-color: var(--green-4);
  color: var(--background-1);
}

.btn-submit:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-reply-now {
  background-color: var(--background-1);
  color: var(--green-4);
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  border: 1px solid var(--green-4);
  transition: background-color 0.2s ease;
}

.btn-reply-now:hover {
  background-color: var(--grey-10);
  color: var(--green-4);
}

.btn-request-again {
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: transparent;
  color: var(--green-4);
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  border: none;
  padding: 0;
  transition: opacity 0.2s ease;
}

.btn-request-again:hover {
  opacity: 0.8;
  color: var(--green-4);
}

.icon-arrow-back {
  width: 24px;
  height: 24px;
}
</style>
